module.exports = __webpack_public_path__ + "media/components/blocks/ProUpsell/pro_header-1da4bbcaba8b4313d0aca9b2be1bd91e.png";